import { notification } from "antd";
import Helper from "../../Helper";
import { WaypointDirection } from "../../models/WaypointDirection";
import { WaypointStep } from "../../models/WaypointStep";
import { plotFetch } from "../Helper/ApiRequest";

const convertWaypointToFormData = (waypointDirection: WaypointDirection): FormData => {
    const formData = new FormData();
    formData.append("waypoint_direction[area_id]", waypointDirection.areaId.toString());
    if (waypointDirection.id) formData.append("waypoint_direction[id]", waypointDirection.id.toString());
    if (waypointDirection.waypointSteps) {
        waypointDirection.waypointSteps.forEach((step, index) => {
            if (step.id)
                formData.append(`waypoint_direction[waypoint_steps_attributes][${index}][id]`, step.id.toString());
            if (step.color)
                formData.append(`waypoint_direction[waypoint_steps_attributes][${index}][color]`, step.color);
            formData.append(
                `waypoint_direction[waypoint_steps_attributes][${index}][icon]`,
                step.icon ? step.icon : ""
            );
            if (step.hidden !== undefined)
                formData.append(
                    `waypoint_direction[waypoint_steps_attributes][${index}][hidden]`,
                    step.hidden.toString()
                );
            if (step.iconRotate !== undefined)
                formData.append(
                    `waypoint_direction[waypoint_steps_attributes][${index}][icon_rotate]`,
                    step.iconRotate.toString()
                );
            if (step.stepNumber !== undefined)
                formData.append(
                    `waypoint_direction[waypoint_steps_attributes][${index}][step_number]`,
                    step.stepNumber.toString()
                );
            if (step.instruction)
                formData.append(
                    `waypoint_direction[waypoint_steps_attributes][${index}][instruction]`,
                    step.instruction
                );
            if (step.coordinates)
                step.coordinates.forEach((coord, coordIndex) => {
                    formData.append(
                        `waypoint_direction[waypoint_steps_attributes][${index}][coordinates][]`,
                        coord.toString()
                    );
                });
            if (step.picture)
                formData.append(`waypoint_direction[waypoint_steps_attributes][${index}][picture]`, step.picture);
            if (step._destroy)
                formData.append(
                    `waypoint_direction[waypoint_steps_attributes][${index}][_destroy]`,
                    step._destroy.toString()
                );
        });
    }
    return formData;
};

export async function createWaypointDirection(
    waypointDirection: WaypointDirection,
    team_subdomain: string,
    project_token: string
): Promise<WaypointDirection> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/waypoint_directions`;
    return plotFetch(url, {
        method: "POST",
        body: convertWaypointToFormData(waypointDirection),
    }).then((response) => response.json());
}

export async function destroyWaypointDirection(
    waypointDirection: WaypointDirection,
    team_subdomain: string,
    project_token: string
): Promise<void> {
    if (!waypointDirection?.id) {
        throw new Error("Cannot delete Waypoint Direction without an id");
    }
    if (waypointDirection.areaId == null) {
        throw new Error("Cannot delete Waypoint Direction without an areaId");
    }

    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/waypoint_directions/${waypointDirection.id}`;
    return plotFetch(url, {
        method: "DELETE",
        body: convertWaypointToFormData(waypointDirection),
    }).then((response) => {
        if (!response.ok) {
            throw new Error("Failed to delete Waypoint Direction");
        }
    });
}

export async function updateWaypointDirection(
    waypointDirection: WaypointDirection,
    team_subdomain: string,
    project_token: string
): Promise<WaypointDirection> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/waypoint_directions/${waypointDirection.id}`;
    return plotFetch(url, {
        method: "PUT",
        body: convertWaypointToFormData(waypointDirection),
    }).then((response) => response.json());
}

export function deleteWaypointStepAttachment(
    subdomain: string,
    projectToken: string,
    waypointStep: WaypointStep
): Promise<boolean> {
    const url = `${Helper.baseUrlAltSubdomain(subdomain)}/projects/${projectToken}/waypoint_steps/${waypointStep.id}/picture`;
    return plotFetch(url, {
        method: "DELETE",
        credentials: "include",
    })
        .then((response) => {
            if (response.ok) {
                notification.success({
                    title: "Attachment Removed",
                    description: "The attachment has been successfully removed.",
                });
                return true;
            }
            throw new Error(response.statusText || "Failed to remove attachment");
        })
        .catch((error) => {
            notification.error({
                title: "Error Removing Attachment",
                description: error?.message ?? String(error),
            });
            return false;
        });
}
